<i18n>
  {
    "fr": {
      "general-terms-and-conditions": "Conditions Génerales de Ventes",
      "about-us": "À propos de nous",
      "privacy": "Vie privée & données personnelles"
    },
    "en": {
      "general-terms-and-conditions": "General Terms And Conditions",
      "about-us": "About us",
      "privacy": "Privacy & personal data"
    }
  }
</i18n>

<template>
  <v-app
    id="app"
  >
    <ErrorParserAlert
      v-if="errorParserAlert"
      :error="error"
    />
    <MainHeader />
    <v-main>
      <v-container
        id="main-container"
        fluid
      >
        <router-view />
      </v-container>
    </v-main>
    <v-footer
      padless
    >
      <v-row
        align="center"
        justify="space-around"
      >
        <v-col
          cols="12"
          lg="4"
          xs="12"
          class="text-center"
        >
          <v-btn
            text
            color="primary"
            @click="$router.push({ name: 'GeneralTermsAndConditions' })"
          >
            {{ $t('general-terms-and-conditions') }}
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          xs="12"
          class="text-center"
        >
          <v-btn
            text
            color="primary"
            @click="$router.push({ name: 'AboutUs' })"
          >
            {{ $t('about-us') }}
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          xs="12"
          class="text-center"
        >
          <v-btn
            text
            color="primary"
            @click="$router.push({ name: 'Privacy' })"
          >
            {{ $t('privacy') }}
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import urls from './constants/urls'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import MainHeader from '@/components/General/MainHeader/MainHeader'
import ErrorParserAlert from '@/components/General/ErrorParserAlert/ErrorParserAlert'

export default {
  name: 'App',
  components: {
    MainHeader,
    ErrorParserAlert
  },
  data: () => ({
    sessionInterval: null,
    sessionValidity: true
  }),
  computed: {
    ...mapState({
      loggedIn: state => state.general.logged,
      sessionExpirationTime: state => state.general.sessionExpirationTime,
      error: state => state.general.error
    }),
    errorParserAlert () {
      let alert = false
      if (this.error !== undefined) { alert = true }
      return alert
    }
  },
  watch: {
    loggedIn (newVal) {
      if (newVal === true) {
        this.setSessionInterval()
      } else if (newVal === false) {
        window.location = urls.sfi.unauthorizedRedirectUrl()
      }
    },
    sessionValidity (newValidity) {
      if (newValidity === false) {
        window.location = urls.sfi.unauthorizedRedirectUrl()
      }
    }
  },
  created () {
    if (process.env.NODE_ENV === 'development') this.developmentInit()
    else this.productionInit()
  },
  beforeDestroy () {
    clearInterval(this.sessionInterval)
  },
  methods: {
    ...mapActions({
      initCountriesList: 'general/initCountriesList',
      changeSessionExpirationTime: 'general/changeSessionExpirationTime'
    }),
    developmentInit () {
      const importCustomer = require('./stubs/customerStub')
      const importClassTypes = require('./stubs/classTypesStub')
      this.$store.commit('general/changeCustomer', importCustomer.default)
      this.$store.commit('fb/searchParameters/changeClassTypes', importClassTypes.default)
      this.initCountriesList()
    },
    productionInit () {
      this.initCountriesList()
      this.hasToBeRedirected()
    },
    setSessionInterval (sessionExpirationObject) {
      this.sessionInterval = setInterval(() => {
        const now = moment()
        this.sessionValidity = sessionExpirationObject.diff(now, 's') > 0
      }, 600000)
    },
    hasToBeRedirected () {
      if (this.$route.name !== 'CodeAccept' && !this.loggedIn) {
        window.location = urls.sfi.unauthorizedRedirectUrl()
      }
    }
  }
}

</script>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

  @font-face {
    font-family: 'Gotham';
    src: url("/assets/fonts/GOTHAM-BOOK.ttf");
    font-weight: normal;
  }

  @font-face {
    font-family: 'Gotham';
    src: url("/assets/fonts/GOTHAM-BOLD.ttf");
    font-weight: bold;
  }

  .v-application {
    font-family: "Gotham", sans-serif !important;
  }

  #app {
    background-image: url("./assets/img/background.jpg");
    background-attachment: fixed;
    background-size: cover;
  }

  #main-container {
    padding: 0 !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
